export const iconCodeToString = {
  1: 'flame',
  2: 'fast-forward',
  3: 'speech-bubble-with-dots',
};
